import type { CartResponse } from '@frontend/libs/hooks/useCart'
import type { Response } from '@frontend/libs/types/common'
import type { Product } from '@frontend/libs/types/product'

import { endpoint } from '@shared/services/endpoint'
import {
  deleteRequest,
  getRequest,
  sendRequest,
} from '@shared/services/fetcher'
import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'

type AddToWishlistRequest = {
  productId: number
}

export const useAddWishlist = () => {
  const {
    data,
    error,
    isMutating: isLoading,
    trigger,
  } = useSWRMutation<CartResponse, Error, string, AddToWishlistRequest>(
    endpoint.frontend.WISHLIST,
    sendRequest,
  )

  const addItem = async (request: AddToWishlistRequest) => {
    return await trigger(request)
  }

  return { addItem, data, error, isLoading }
}

export const useGetWishlist = () => {
  return useSWR<Response<Product[]>, Error>(
    endpoint.frontend.WISHLIST,
    getRequest,
  )
}

export const useRemoveWishlist = (id: number) => {
  const {
    data,
    error,
    isMutating: isLoading,
    trigger,
  } = useSWRMutation<CartResponse, Error>(
    `${endpoint.frontend.WISHLIST}/${id}`,
    deleteRequest,
  )

  const removeItem = async () => {
    return await trigger()
  }

  return { data, error, isLoading, removeItem }
}
